
namespace GeniuzPOS.AdvPromo {
    import fld = VwAdvPromoBasicAndAdvActiveByPluRow.Fields
    @Serenity.Decorators.registerClass()
    export class VwAdvPromoBasicAndAdvActiveByPluGrid extends Serenity.EntityGrid<VwAdvPromoBasicAndAdvActiveByPluRow, any> {
        protected getColumnsKey() { return VwAdvPromoBasicAndAdvActiveByPluColumns.columnsKey; }
        protected getDialogType() { return VwAdvPromoBasicAndAdvActiveByPluDialog; }
        protected getIdProperty() { return VwAdvPromoBasicAndAdvActiveByPluRow.idProperty; }
        protected getInsertPermission() { return VwAdvPromoBasicAndAdvActiveByPluRow.insertPermission; }
        protected getLocalTextPrefix() { return VwAdvPromoBasicAndAdvActiveByPluRow.localTextPrefix; }
        protected getService() { return VwAdvPromoBasicAndAdvActiveByPluService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["PromoCampaign","PmId"]);
            // groupingMixin.plugin.setDroppedGroups(["PluCode"]);


        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: VwAdvPromoBasicAndAdvActiveByPluService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons
        }
        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.PromoStatus).init = w => {

                (w as Serenity.EnumEditor).value = "1";
                
            };
         
            
            return filters;
        }


    }
}